import { Injectable } from '@angular/core';
import { StockItem } from 'src/app/core';
import { PrintBlockItem } from 'src/app/shared';

@Injectable({ providedIn: 'any' })
export class OrderPriceController {
  // Constructor ------------------------------------------>

  constructor() { }

  // Public methods --------------------------------------->

  public calculateBlocksPrice(blocks: PrintBlockItem[]) {
    let price = 0;
    console.log("bb", blocks)
    let listTypeBlock: any[] = []
    blocks.forEach((block) => {
      const stockPrice = parseInt(block.stock?.price || `0`);
      const pageNumbers = this.getRangesPageCount([block]);
      listTypeBlock.push({ range: pageNumbers, type: block.stock?.type, price: stockPrice });
      // if(price > 0 && block.stock?.type?.indexOf('bw') != -1)
      // price += pageNumbers * stockPrice;
    });

    if (listTypeBlock.length == 1)
      price = listTypeBlock[0].range * listTypeBlock[0].price;
    else {
      let totalRangeWithoutBlackAndWhite: any = 0;

      listTypeBlock.forEach((block) => {
        if (block.type != '1bw' && block.type != '2bw')
          totalRangeWithoutBlackAndWhite += block.range;
      })
      let indexBlackAnaWhite = listTypeBlock.findIndex(item => item.type.indexOf('bw') != -1)
      listTypeBlock[indexBlackAnaWhite].range = listTypeBlock[indexBlackAnaWhite].range - totalRangeWithoutBlackAndWhite
      listTypeBlock.forEach((block) => {
        price += block.range * block.price;
      })
    }

    return price;

  }

  public getRangesPageCount(blocks: PrintBlockItem[]) {

    const pageNumbers = blocks.map((block) => {
      let oneSided = block.stock?.type?.indexOf("2") == -1 ? true : false;

      if (+block.start === 0 && +block.end === 0) {
        return 0;
      }

      if (block.start === block.end) return 1;

      if (oneSided)
        return block.end - block.start;
      else {
        let pageNumber = block.end - block.start
        let pageCalc = (block.end - block.start) / 2
        if (pageNumber % 2 != 0)
          return Math.floor(pageCalc) + 1;
        return pageCalc
      }
    });

    if (pageNumbers.length === 1) {
      return pageNumbers[0];
    } else {
      return pageNumbers.reduce((a, b) => a + b);
    }
  }

  public calculateBindingPrice(binding?: StockItem): number {
    if (!binding) return 0;
    return +binding.price;
  }
}
